import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getContentExtract } from '../utils/htmlUtils';
import { API_BASE_URL } from '../config/api';

const HomePage = () => {
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isClient, setIsClient] = useState(false);

    useEffect(() => {

        setIsClient(true);
        fetchPosts();
    }, []);

    const fetchPosts = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}/api/posts/`);
            if (!response.ok) throw new Error('Error al cargar las entradas');

            const data = await response.json();
            const sortedPosts = data.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
            setPosts(sortedPosts);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching posts:', error);
            setLoading(false);
        }
    };

    if (loading) {
        return <div className="loading">Cargando entradas...</div>;
    }

    if (posts.length === 0) {
        return <p className="no-posts">No hay entradas todavía.</p>;
    }

    return (
        <div className="home-page">
            <h2 id='HomePageSubtitle'> </h2>

            {posts.map((post, index) => (
                <article key={post.id} className={`post-preview ${index === 0 ? 'featured-post' : ''}`}>
                    <h3>
                        <Link to={`/post/${post.slug}`}>{post.title}</Link>
                    </h3>


                    {isClient && (
                        <div
                            className="post-excerpt"
                            dangerouslySetInnerHTML={{
                                __html: getContentExtract(post.html_content, index === 0)
                            }}
                        />
                    )}


                    {!isClient && (
                        <div className="post-excerpt">
                            <p>Cargando contenido...</p>
                        </div>
                    )}


                    <div className="post-meta">
                        <span className="post-date">
                            {new Date(post.created_at).toLocaleDateString('es-ES', {
                                year: 'numeric',
                                month: 'long',
                                day: 'numeric'
                            })}
                        </span>
                        <span className="post-likes">
                            👍 {post.likes}
                        </span>
                        <Link to={`/post/${post.slug}`} className="read-more-btn">
                            Leer más
                        </Link>
                    </div>
                </article>
            ))}
        </div>
    );
};

export default HomePage;